import { type Static, Type } from '@sinclair/typebox';

export const ConfigDTOSchema = Type.Object({
  payments: Type.Object({
    platformFee: Type.Number({ minimum: 0, maximum: 100 }),
  }),
  supportedCountries: Type.Array(Type.String()),
});
export type ConfigDTO = Static<typeof ConfigDTOSchema>;
